module.exports = __webpack_public_path__ + "img/progress-end.14e1d298.png";